import { LuWorkflow } from 'react-icons/lu';
import ResourceListPage from '../../components/resource-list-page';
import { deleteAgentActionSettings } from '../../services/prompt-ai';
import useJourneyList from '../action-journey-studio/journey/journey-list/useJourneyList';
import JourneyCreateDialog from '../action-journey-studio/journey/journey-create';

export default function WorkflowListPage() {
    const list = useJourneyList();
    return (
        <ResourceListPage
            key={list.appId}
            title="Workflows"
            singular="Workflow"
            subtitle="Build visual workflows that guide your agent through repeatable processes."
            emptyDescription="Create a workflow to connect actions, decisions, and conversations on the canvas."
            icon={LuWorkflow}
            list={list}
            basePath="/journey"
            deleteItem={deleteAgentActionSettings}
            renderEditor={({ item, ...callbacks }) => <JourneyCreateDialog journeyId={item.id} {...callbacks} />}
        />
    );
}
